import * as React from "react";
import {Footer} from '../../component/layout/Footer';
import {Navigation} from '../../component/layout/Navigation';
import {GalleryGridItem} from '../../component/gallery/GalleryGridItem';
import {IReadGalleryResponse} from "../../core/api/post/response/ReadGalleryResponse";
import {PostApiService} from "../../core/api/post/PostApiService";

interface IProps {
    componentName?: string;
}

interface IState {
    data: IReadGalleryResponse[] | undefined;
}

export class Gallery extends React.Component<IProps, IState> {

    private readonly postService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: undefined
        }
    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div id="gallery-page" className="page client-area">
                <Navigation navClass="main-nav js-stick" />

                <section className="page-section bg-dark-alfa-30 parallax-3 gallery-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">Galeri</h1>
                                <div className="hs-line-4 font-alt black">Foto-foto dokumentasi kegiatan desa Sanur Kauh</div>
                            </div>
                            <div className="col-md-4 mt-30">
                                <div className="mod-breadcrumbs font-alt align-right"><a
                                    href="/">Beranda</a>&nbsp;/&nbsp;Galeri</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">
                        <div className="row multi-columns-row mb-30 mb-xs-10">

                            {this.state.data === undefined ? <p>Loading...</p> : (
                                <div>
                                    {this.state.data.length < 1 ? <p>Tidak ada data galeri.</p> : this.state.data.map((item, index) =>
                                        <div className="col-md-3 col-lg-3 mb-md-10" key={index}>
                                            <GalleryGridItem data={item} />
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                </section>

                <Footer />
            </div>
        );
    }

    private fetchData = () => {
        this.postService.getGallery(0)
            .then((response: any) => {
                this.setState({
                    data: response.result
                })
            }).catch((error) => {
            this.setState({
                data: []
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/screen/gallery/Gallery.tsx